import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormNumberInput } from './FormField';
import { useFieldLayout } from './useFieldLayout';

type NumberFieldProps = Omit<
  ComponentProps<typeof FormNumberInput>,
  'label' | 'inputHeight' | 'inputBackground'
> &
  FieldLayoutOptions;

export const NumberField = ({ label, hideLabel, ...fieldProps }: NumberFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormNumberInput
      label={field.label}
      aria-label={field.ariaLabel}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
